<template>
  <div class="my-modal-overlay"
    :class="[show ? 'opened-dialog' : 'closed-dialog']">
    <div class="dialog-container">
      <v-card flat id="edit-inspection-card" class="my-card">
        <v-row>
          <v-col class="d-flex align-center" cols md="4">
            <div class="inspections-title-icon">
              <v-img
                contain
                height="24"
                width="24"
                src="@/assets/microphone.svg"
              ></v-img>
            </div>
            <div>
              <h2>{{$t("editInspection")}}</h2>
            </div>
          </v-col>

          <v-col cols="12" sm="8" md="4" offset-sm="1" offset-md="4">
            <date-picker
              v-model="audioInspectionDate"
              :placeholder="$t('selectDate')"
              value-type="date"
              format="MMMM D, YYYY"
              :clearable="false"
              class="datepicker-container"
              popup-class="my-datepicker-popup"
              input-class="datepicker-btn datepicker-btn-sm"
              :lang="lang"
            >
              <template v-slot:icon-calendar>
                <v-img src="@/assets/calendar.svg"></v-img>
              </template>
            </date-picker>
          </v-col>
          <v-col class="d-none d-sm-block"></v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <label class="my-label">{{$t('title')}}</label>
            <v-text-field
              v-model="title"
              solo
              flat
              hide-details
              color="#262338"
              background-color="#EFF0F7"
              class="my-input"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-8">
          <v-col cols="12">
            <v-textarea
              v-model="notes"
              :label="$t('add_details')"
              filled
              color="#262338"
              background-color="#EFF0F7"
              auto-grow
              class="my-textarea"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-card-actions class="my-card-actions inspections-actions">
          <v-row>
            <v-col md="5" lg="6" xl="7" class="d-none d-sm-none d-md-block"></v-col>
            <v-col cols="12" sm>
              <v-btn
                height="54px"
                outlined
                block
                class="my-btn red-btn"
                @click="cancelBtnAction"
              >
                {{$t("cancel")}}
                <v-spacer></v-spacer>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" sm>
              <v-btn
                height="54px"
                depressed
                block
                dark
                @click.stop="saveBtnAction"
                class="my-btn save-btn"
                :disabled="!isValidInspection"
              >
                {{$t("save")}}
                <v-spacer></v-spacer>
                <v-icon>{{check_icon}}</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';

  import moment from "moment";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/locale/el';
  import 'vue2-datepicker/locale/en';
  import 'vue2-datepicker/locale/es';
  import 'vue2-datepicker/index.css';

  export default {
    name: 'ActionsModal',
    components: {
      DatePicker
    },
    props: {
     visible: Boolean
    },
    computed: {
      ...mapGetters([
        "editInspectionDetails"
      ]),
      show: {
        get () {
          return this.visible
        },
        set (value) {
           if (!value) {
            this.$emit('close');
          }
        }
      },
      lang: {
        get() {
          return this.$i18n.locale;
        }
      },
      audioInspectionDate: {
        get () {
          let inspectionDate = this.$store.state.audioInspections.editInspectionDetails.date;
          let date = new Date(inspectionDate);
          return date;
        },
        set(value) {
          let date = moment(value).format("YYYY-MM-DD");
          this.$store.commit('setEditInspectionDetailsProp', {prop: 'date', value: date});
        }
      },
      title: {
        get () {
          let result = '';
          if (Object.keys(this.$store.state.audioInspections.editInspectionDetails).length != 0) {
            result = this.$store.state.audioInspections.editInspectionDetails.title;
          }
          return result;
        },
        set(value) {
          this.$store.commit('setEditInspectionDetailsProp', {prop: 'title', value: value});
        }
      },
      notes: {
        get () {
          let result = '';
          if (Object.keys(this.$store.state.audioInspections.editInspectionDetails).length != 0) {
            result = this.$store.state.audioInspections.editInspectionDetails.notes;
          }
          return result;
        },
        set(value) {
          this.$store.commit('setEditInspectionDetailsProp', {prop: 'notes', value: value});
        }
      },
      isEditItemEmpty() {
        return Object.keys(this.editInspectionDetails).length === 0;
      },
      isValidInspection() {
        let validationProps = ['title'];
        let isValid = true;

        for (let k = 0; k < validationProps.length; k++) {
          let prop = validationProps[k];
          if (!this.isEditItemEmpty && this.editInspectionDetails[prop] != undefined) {
            if (this.editInspectionDetails[prop] === '') {
              isValid = false;
            }
          }
        }
        return isValid;
      },
    },
    data: () => ({
      publicPath: process.env.BASE_URL,
      check_icon: "$vuetify.icons.check_icon",
    }),
    methods: {
      cancelBtnAction() {
        this.$emit('close');
      },
      saveBtnAction() {
        this.$emit('save');
      }
    }
  }
</script>

<style type="text/css">
  #edit-inspection-card {
    position: relative;
  }

  @media screen and (max-width: 960px) {
    #edit-inspection-card.my-card {
      padding: 35px 25px;
    }

    #edit-inspection-card.my-card .v-tabs.inspections-tabs {
      margin: 15px -25px 0;
    }
  }

  @media screen and (max-width: 600px) {
    #hive-management-page #edit-inspection-card.my-card {
      padding: 35px 25px 70px;
    }
  }
</style>
